import React from 'react';

import {
    buildDefaultShareMessage,
    buildMailtoHref,
    buildSmsHref,
    canUseNativeShare,
    openNativeShare,
} from '../../../utils/gifting_page_share';

import './Share_overlay_buttons.css';

/**
 * Share overlay actions: copy link, email, text, and native share on mobile.
 */
export default function Share_overlay_buttons({
    shareUrl,
    childName,
    shareMessage,
    nativeShareMessage,
    shareTitle,
    onCopyLink,
    onChannelSelect,
}) {
    const message = shareMessage || buildDefaultShareMessage(childName);
    const nativeText = nativeShareMessage || message;
    const title = shareTitle || `Invest in ${childName}'s future`;
    const shareData = { url: shareUrl, text: nativeText, title };
    const showMoreOptions = canUseNativeShare(shareData);

    const logChannel = (channel) => {
        if (onChannelSelect) onChannelSelect(channel);
    };

    const handleCopyLink = () => {
        logChannel('copy link');
        onCopyLink();
    };

    const handleMoreOptions = () => {
        logChannel('more options');
        openNativeShare({
            url: shareUrl,
            text: nativeText,
            title,
            onChannelSelect: (channel) => logChannel(channel),
        });
    };

    return (
        <div className='overlay_share_button_container'>
            <div
                className='overlay_share_button overlay_share_button_primary'
                onClick={handleCopyLink}
            >
                <i className='material-icons-outlined'>link</i>
                <span className='tiny_text'>Copy link</span>
            </div>

            <a
                className='overlay_share_button'
                href={buildMailtoHref(message, shareUrl)}
                onClick={() => logChannel('email')}
            >
                <i className='material-icons-outlined'>email</i>
                <span className='tiny_text'>Send email</span>
            </a>

            <a
                className='overlay_share_button'
                href={buildSmsHref(message, shareUrl)}
                onClick={() => logChannel('textsms')}
            >
                <i className='material-icons-outlined'>textsms</i>
                <span className='tiny_text'>Send text</span>
            </a>

            {showMoreOptions ? (
                <div className='overlay_share_button' onClick={handleMoreOptions}>
                    <i className='material-icons-outlined'>ios_share</i>
                    <span className='tiny_text'>More options</span>
                </div>
            ) : null}
        </div>
    );
}
